// Shared FAQ content — used by the /faq page. Mirrored in scripts/prerender.js
// (for static FAQPage JSON-LD) so keep the two in sync when editing.
export const faqs = [
  {
    q: "What does a crisis communications firm do?",
    a: "A crisis communications firm — or crisis PR firm — gives crisis management help to organizations and individuals facing reputational threats, litigation, or media scrutiny. We verify the facts, define the message, and coordinate communications across media, employees, investors, regulators and the public to protect and restore trust.",
  },
  {
    q: "How do I hire a crisis communications consultant?",
    a: "Email info@parkcomms.com or use our contact form with a short, confidential note about your situation. We respond quickly, and every message is read personally. We'll tell you honestly what your situation actually needs.",
  },
  {
    q: "How should I respond to a PR crisis?",
    a: "Move fast but deliberately: confirm the facts before you speak, align your internal and external messaging, prepare a clear and honest statement, and engage experienced crisis communications support before responding publicly. Silence and over-reaction are both risks — a plan is what keeps you in control.",
  },
  {
    q: "How quickly can a crisis PR firm respond to a breaking situation?",
    a: "Immediately. Crises don't keep business hours — for active situations we mobilize the same day, often within the hour, to assess the facts, contain the story, and get a response strategy in front of you fast.",
  },
  {
    q: "What should I do when my company is in the news for the wrong reasons?",
    a: "Get ahead of the story. Establish the facts, decide who your key audiences are, and give them one clear, consistent message. Coordinate legal and communications from the start, brief your spokespeople, and monitor coverage so you can correct the record quickly and fairly.",
  },
  {
    q: "How do I handle negative press or a viral post about my company?",
    a: "Assess reach and accuracy first — not everything requires a public response. When it does, respond with facts, empathy and speed, in the right channel, and follow up with proactive coverage that reframes the story. We help clients decide when to engage, when to wait, and exactly what to say.",
  },
  {
    q: "How much does crisis PR cost?",
    a: "It depends on scope. An acute, single-event engagement is priced differently from ongoing retained counsel. After a short, confidential intake we provide a clear proposal with no obligation.",
  },
  {
    q: "What's the difference between crisis management and public relations?",
    a: "Public relations builds visibility and reputation over time; crisis management protects it under pressure. As both a public relations agency and a crisis communications firm, Park Communications does both — issues management, damage control, and the media and stakeholder communications that get you through a high-stakes moment.",
  },
  {
    q: "Do you offer executive media training?",
    a: "Yes. We provide executive media training and spokesperson training so leaders can handle tough interviews, hostile questions and negative press with confidence — a core part of any crisis communications plan.",
  },
  {
    q: "What is reputation management and online reputation monitoring?",
    a: "Reputation advisory is the ongoing, deliberate work of protecting credibility: reputation audits, risk mapping, issue and stakeholder monitoring, and online reputation monitoring so problems are caught early. It's the quiet work that keeps a crisis from happening in the first place.",
  },
  {
    q: "Who does Park Communications work with?",
    a: "We are a public relations agency for executives and CEOs, legal teams, entertainment, athletes, actors and musicians, founders and public figures, and government, nonprofit and enterprise institutions.",
  },
  {
    q: "Where is Park Communications located?",
    a: "We serve Los Angeles and clients across California, and Washington, DC — and we are available for emergency crisis communications support nationwide.",
  },
  {
    q: "Do you only work during a crisis?",
    a: "No. Alongside crisis work, we act as a strategic communications agency for the long game — reputation management, media relations and positioning that build credibility well before it is ever tested.",
  },
];
